export const visit = (vm, at) => {
at({ "en-gb": { "conversations-visitor-experience-components": { "emailCapture": { "failedToPublish": "Sorry, we couldn't verify your email address." } } } });
};